import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';

import { NavService } from './../navigation/navigation.service';
import { CVFormService } from './../coverage-form.service';
import { FormPreliminary } from './../coverage-form.interface';

import {
  PaxFormControlService,
  BackendService,
  BobtailStore,
  SAVE_FORM,
  UPDATE_STORE
} from './../../shared/index';
import { FormVehiclesInformationService } from './form-vehicles-information.service';

@Component({
  selector: 'pax-cf-form-vehicles-information',
  template: require('./form-vehicles-information.component.html'),
  providers: [
    PaxFormControlService,
    FormVehiclesInformationService
  ]
})
export class FormVehiclesInformationComponent implements OnInit, OnDestroy {
  formVehiclesInformation: FormGroup;
  questionsTruck: any[];
  questionsTrailer: any[];
  getQuestionOtherTrailerType: any;
  fgTruck: FormGroup;
  fgTrailer: FormGroup;
  preliminary: FormPreliminary = {
    zip: '',
    truckValue: ''
  };
  payload: Object = {};
  storeData;
  routeData;
  formSubmitted = false;

  constructor(
    private _store: Store<any>,
    private _backend: BackendService,
    private FormControlService: PaxFormControlService,
    private dataService: FormVehiclesInformationService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _cv: CVFormService,
    private _ns: NavService
  ) {}

  ngOnInit() {
    // resolve router data
    this.routeData = this._route.data.subscribe((data) => {
      this._store.dispatch({ type: UPDATE_STORE, payload: { steps: data['forms'][1], settings: data['forms'][0] } });
    });

    // get fields array from the service
    this.questionsTruck = this.dataService.getTruckInfo();

    // init the form
    this.formVehiclesInformation = new FormGroup({});

    this.fgTruck = this.FormControlService.toFormGroup(this.questionsTruck);
    this.formVehiclesInformation.addControl('truck', this.fgTruck);

    // get data from store and prefill the form
    this.storeData = this._store.select('cvform').subscribe((store: BobtailStore) => {
      let patchProps = { truck: {}, trailer: {}};
      let storeForm = store.steps['vehicles-information'] || {};

      // get zip code from preliminary step ...
      if (store.steps['preliminary']) {
        this.preliminary = store.steps['preliminary'];
        patchProps['truck']['truckValue'] = this.preliminary['truckValue'] || '';
        patchProps['trailer']['trailerValue'] = this.preliminary['trailerValue'] || '';
      }

      // merge the two objects, so that store override preliminary
      this.payload['truck'] = Object.assign({}, storeForm['truck'], patchProps['truck']);
      this.payload['trailer'] = Object.assign({}, storeForm['trailer'], patchProps['trailer']);
    });

    // subscribe to truck value control
    this.fgTruck.controls['truckValue'].valueChanges.subscribe((value) => {
      this.updateTruckValue(value);
    });

    // check for Trailer
    if (this.payload['trailer']['trailerValue']) {
      this.addTrailerFields();
    }

    // update the form
    this.formVehiclesInformation.patchValue(this.payload || {});
  }

  addFieldOtherType() {
    if (!this.fgTrailer.contains('trailerOtherType')) {
      this.getQuestionOtherTrailerType = this.dataService.getQuestionOtherTrailerType();
      this.questionsTrailer.splice((this.getQuestionOtherTrailerType.order - 1), 0, this.getQuestionOtherTrailerType);
      this.fgTrailer.addControl('trailerOtherType', this.FormControlService.toFormControl(this.getQuestionOtherTrailerType));
    }
  }

  removeFieldOtherType() {
    if (this.fgTrailer.contains('trailerOtherType')) {
      this.questionsTrailer.splice((this.getQuestionOtherTrailerType.order - 1), 1);
      this.fgTrailer.removeControl('trailerOtherType');
    }
  }

  ngOnDestroy() {
    this.storeData.unsubscribe();
    this.routeData.unsubscribe();
  }

  updateTruckValue(value) {
    this._store.dispatch({ type: SAVE_FORM, payload: this.formVehiclesInformation.valid ? {
        preliminary: Object.assign({}, this.preliminary, { truckValue: value }),
        'vehicles-information': Object.assign({}, this.payload, {
          truck: Object.assign({}, this.payload['truck'], { truckValue: value })
        })
      } : {
        preliminary: Object.assign({}, this.preliminary, { truckValue: value })
      }
    });
  }

  updateTrailerValue(value) {
    this._store.dispatch({ type: SAVE_FORM, payload: this.formVehiclesInformation.valid ? {
        preliminary: Object.assign({}, this.preliminary, { trailerValue: value }),
        'vehicles-information': Object.assign({}, this.payload, {
          trailer: Object.assign({}, this.payload['trailer'], { trailerValue: value })
        })
      } : {
        preliminary: Object.assign({}, this.preliminary, { trailerValue: value })
      }
    });
  }

  removeTrailerFields() {
    this.questionsTrailer = undefined;
    // this.fgTrailer['trailerOtherType'].valueChanges.unsubscribe();
    this.formVehiclesInformation.removeControl('trailer');

    this._store.dispatch({ type: SAVE_FORM, payload: {
        preliminary: Object.assign({}, this.preliminary, { trailerValue: null })
    }});
  }

  addTrailerFields() {
    // if already added
    if (this.questionsTrailer) { return false; }
    // get fields array from the service
    this.questionsTrailer = this.dataService.getTrailerInfo();
    // add Trailer controls to the form
    this.fgTrailer = this.FormControlService.toFormGroup(this.questionsTrailer);
    this.formVehiclesInformation.addControl('trailer', this.fgTrailer);

    // subscribe to truck value control
    this.fgTrailer.controls['trailerValue'].valueChanges.subscribe((value) => {
      this.updateTrailerValue(value);
    });

    this.fgTrailer.controls['trailerType'].valueChanges.subscribe((value) => {
      if (value === 'typeOther') {
        this.addFieldOtherType();
      } else  {
        this.removeFieldOtherType();
      }
    });

    // update the form
    this.formVehiclesInformation.patchValue(this.payload || {});

  }

  onSubmit() {
    this.formSubmitted = true;

    Promise.all([
      this._cv.sendToServerAndUpdateStore('preliminary', this.preliminary),
      this._cv.sendToServerAndUpdateStore('vehicles-information', this.formVehiclesInformation.value)
    ])
    .then(() => {
      this._ns.manualActiveStep('driver-information');
      this._router.navigate(['']);
    })
    .catch(err => console.log(err));
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./resources/themes/pandax/bobtail/app/coverage-form/form-vehicles-information/form-vehicles-information.component.ts